import DuckEntity from './DuckEntity'
import {actionize, apiAction, apiFetch} from 'utils';
import {push} from 'react-router-redux';

const duck = new DuckEntity('paymentVerifications');

let types = {
  VERIFY_AMOUNTS: null,
  VERIFY_AMOUNTS_SUCCESS: null,
  VERIFY_AMOUNTS_ERROR: null
};
types = actionize(types, (action) => `schooladmin/payment_verifications/${action}`);


const verifyAmounts = (paymentVerification, amount_1, amount_2) =>
  apiAction(
    types.VERIFY_AMOUNTS, types.VERIFY_AMOUNTS_SUCCESS, types.VERIFY_AMOUNTS_ERROR,
    (state) => apiFetch.post(state, `${duck.config.apiPath}/${paymentVerification.id}/verify`, {amount_1, amount_2}, {/*options...*/}),
    {
      entityName: duck.config.name
    },
    { payment_verification: duck.config.schema }
  );

export default duck.reducer;

export const entity = {
  ...duck,
  actions: {
    ...duck.actions,
    verifyAmounts
  }
};
